/**
 * Back-office permission checks. The login response stores the signed-in
 * user's role and permission keys under `user` in localStorage; /auth/me may
 * also carry them, so both are consulted. ADMIN passes every check.
 */
export const PERMISSIONS = {
  MANAGE_MATCHMAKING: "MANAGE_MATCHMAKING",
} as const;

type UserLike = { role?: string | null; permissions?: unknown } | null | undefined;

const readStoredUser = (): UserLike => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const isAdmin = (user: UserLike) =>
  String(user?.role || "").toUpperCase() === "ADMIN";

const holds = (user: UserLike, permission: string) =>
  Array.isArray(user?.permissions) && user!.permissions.includes(permission);

export const hasPermission = (permission: string, contextUser?: UserLike): boolean => {
  const stored = readStoredUser();
  return (
    isAdmin(contextUser) ||
    isAdmin(stored) ||
    holds(contextUser, permission) ||
    holds(stored, permission)
  );
};
